<template>
  <div class="ad-card-list">
    <div class="ad-card-item" v-for="(item, idx) of adList" :key="idx">
      <template v-if="mode === MODE.ONE && idx === 0">
        <AdCard :adCardInfo="item" :mode="DISPLAY.VERTICAL" />
      </template>
      <template v-else-if="mode === MODE.ONE && idx != 0">
        <AdCard :adCardInfo="item" :mode="DISPLAY.HORIZONTAL" />
      </template>
      <template v-else-if="mode === MODE.TWO && idx === 0">
        <div class="list-container">
          <div class="list">
            <div
              class="list-item list-item_two"
              v-for="(subItem, idx) of item"
              :key="'subItem_' + idx"
            >
              <AdCard :adCardInfo="subItem" :mode="DISPLAY.VERTICAL">
                <template v-slot:image>
                  <div class="image_two r-ellipsis-l2">
                    <img :src="subItem._imgSrc" class="img_ad" />
                  </div>
                </template>
                <template v-slot:desc>
                  <div class="desc_two">
                    <div class="sub-title">{{ subItem._subTitle }}</div>
                    <div class="intro">
                      <div class="date">{{ subItem._date }}</div>
                      <div class="num">{{ subItem._clickNum }}观看</div>
                    </div>
                  </div>
                </template>
              </AdCard>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="mode === MODE.TWO && idx != 0">
        <AdCard :adCardInfo="item" :mode="DISPLAY.HORIZONTAL" />
      </template>
      <template v-else-if="mode === MODE.THREE">
        <div class="sub-list">
          <AdCard
            :adCardInfo="subItem"
            :mode="DISPLAY.VERTICAL"
            v-for="(subItem, idx) of item"
            :key="'SUB_ITEM_' + idx"
          >
            <template v-slot:image>
              <div class="image_three">
                <img :src="subItem._imgSrc" class="img_ad" />
              </div>
            </template>
            <template v-slot:desc>
              <div class="desc_three">
                <div class="sub-title r-ellipsis-l2">
                  {{ subItem._subTitle }}
                </div>
                <div class="intro">
                  <div class="date">{{ subItem._date }}</div>
                  <div class="num">{{ subItem._clickNum }}观看</div>
                </div>
              </div>
            </template>
          </AdCard>
        </div>
      </template>
      <template v-else-if="mode === MODE.FOUR">
        <AdCard :adCardInfo="item" :mode="DISPLAY.VERTICAL" />
      </template>
    </div>
  </div>
</template>

<script>
import AdCard from "./ad-card";
import { MODE, DISPLAY } from "../shared";

export default {
  name: "AdCardList",

  props: {
    adList: {
      type: Array,
      default() {
        return [];
      }
    },

    mode: {
      type: String
    }
  },

  data() {
    return {
      MODE: MODE,
      DISPLAY: DISPLAY
    };
  },

  components: {
    AdCard: AdCard
  }
};
</script>

<style lang="scss">
.r-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.r-ellipsis-l2 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>

<style lang="scss" scoped>
.ad-card-list {
  .ad-card-item {
    margin-bottom: 10px;
    .list-container {
      width: 240px;
      overflow: hidden;
      .list {
        display: flex;
        width: 100%;
        overflow-x: scroll;
      }
      .list::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
.list-item_two {
  margin-right: 10px;
  .image_two {
    width: 128px;
    height: 70px;
    .img_ad {
      width: 128px;
      height: 70px;
      border-radius: 6px;
    }
  }
  .desc_two {
    .sub-title {
      margin-top: 5px;
      margin-bottom: 5px;
      height: 25px;
      overflow: hidden;
    }
    .intro {
      color: #999;
    }
  }
}
.list-item_two:last-child {
  margin-right: 0;
}

.sub-list {
  display: flex;
  justify-content: space-between;
  .image_three {
    width: 115px;
    height: 60px;
    .img_ad {
      width: 115px;
      height: 60px;
      border-radius: 6px;
    }
  }
  .desc_three {
    width: 115px;
    .sub-title {
      margin-top: 5px;
      margin-bottom: 5px;
      height: 25px;
      overflow: hidden;
    }
    .intro {
      color: #999;
      overflow: hidden;
      .date {
        width: 60px;
        height: 12px;
        overflow: hidden;
      }
    }
  }
}
</style>
